import Reveal from "@/components/Reveal";
import LeadForm from "@/components/LeadForm";
import { Mail, CalendarClock, Users } from "lucide-react";

const points = [
  { icon: CalendarClock, title: "30-minute walkthrough", desc: "A focused demo against a real ADAC file." },
  { icon: Users, title: "Tailored to your role", desc: "Council reviewer or Consultant — we adapt the session." },
  { icon: Mail, title: "Fast follow-up", desc: "A specialist will be in touch shortly after you submit." },
];

export default function Contact() {
  return (
    <div data-testid="contact-page" className="pt-32 pb-24 md:pt-40">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <Reveal className="max-w-3xl">
          <p className="text-xs font-semibold tracking-[0.2em] uppercase text-[#0033A0] font-mono">Talk to us</p>
          <h1 className="mt-5 font-heading text-4xl sm:text-5xl font-semibold tracking-tighter leading-[1.05] text-zinc-900">
            Book a WebADAC demo
          </h1>
          <p className="mt-6 text-lg text-zinc-600 leading-relaxed">
            Tell us about your ADAC workflow and what you'd like to see. We'll show you how to validate,
            compare, profile, and create ADAC XML with confidence.
          </p>
        </Reveal>

        <div className="mt-14 grid lg:grid-cols-12 gap-10 items-start">
          <Reveal className="lg:col-span-7 order-2 lg:order-1">
            <div className="rounded-2xl border border-zinc-200 bg-white p-8 md:p-10">
              <LeadForm />
            </div>
          </Reveal>

          <Reveal delay={0.1} className="lg:col-span-5 order-1 lg:order-2 space-y-5">
            {points.map((p) => (
              <div key={p.title} className="flex items-start gap-4 rounded-xl border border-zinc-200 bg-white p-6">
                <span className="shrink-0 h-10 w-10 grid place-items-center bg-[#E6EBF5] text-[#0033A0] rounded-sm">
                  <p.icon size={20} strokeWidth={1.6} />
                </span>
                <div>
                  <p className="font-heading font-medium text-zinc-900">{p.title}</p>
                  <p className="mt-1 text-sm text-zinc-600 leading-relaxed">{p.desc}</p>
                </div>
              </div>
            ))}
          </Reveal>
        </div>
      </div>
    </div>
  );
}
